import {collection, component, EntityData, field} from "@fedeltapointofsale/data-client";
import {MixAndMatchInclusionData} from "./mix-and-match.data";

export class MixAndMatchInclusion extends EntityData<MixAndMatchInclusion> {
    @field sellableId: number;
    @field sellableName: string;
    @field customObjectId: number;
    @field customObjectName: string;
    @field includeCompositeComponents: boolean;
    @field extraId: number;
    @field extraName: string;
    @field extraCustomObjectId: number;
    @field extraCustomObjectName: string;
    @field minExtraQty: number;
    @field maxExtraQty: number;

    public matches(product: MixAndMatchInclusionData): boolean {
        return (this.customObjectId && product.customObject.customObjectId === this.customObjectId) ||
            (this.sellableId && product.sellable.sellableId === this.sellableId) ;
    }
}

export class Intersection extends EntityData<Intersection> {
    @component inclusion1: MixAndMatchInclusion;
    @component inclusion2: MixAndMatchInclusion;
}

export enum MixAndMatchComplexity {
    SIMPLE,
    REQUIRES_SORTING,
    SINGLE_INTERSECTION,
    MULTIPLE_INTERSECTIONS,
    INDETERMINATE
}

export class MixAndMatchComplexityAnalysis extends EntityData<MixAndMatchComplexityAnalysis> {
    @field complexity: MixAndMatchComplexity;
    @collection(Intersection) intersections: Intersection[];
    @field limit: number;
}
